var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.maxHeight = {
	init: function (selector, maxHeight) {
		if (!selector || $(selector).length == 0) return;
		site.maxHeight.setHeight(selector, maxHeight);
		$(window).resize(function () {
			site.maxHeight.setHeight(selector, maxHeight);
		});
	},

	setHeight: function (selector, maxHeight) {
		$(selector).each(function () {
			if (maxHeight) {
				$(this).css('max-height', $(this)[0].scrollHeight < maxHeight ? $(this)[0].scrollHeight : maxHeight);
			} else {
				$(this).css('max-height', $(this)[0].scrollHeight);
			}
		});
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.frontpage = {
	init: function() {

	}
};

site.filterCate = {
	init: function () {
		var $parent = $('.categories > li.selected');
		var $selected = $('li.selected > ul');

		$parent.append($selected);
	}
};

site.storefilter = {
	masonryInstance: null,
	init: function() {
		var $body = $('body');
		var $store = $('#store');

		if ($body.hasClass('hasFilter')) {
			site.storefilter.filter();
		}
	},
	filter: function() {
		var $filter = $('#filters');

		$filter.find('.wrap').each(function() {
			site.maxHeight.init($(this), 300);
		});

		$filter.find('.wrap').each(function() {
			$(this).find('input:checked').parents('.option').addClass('selected');
		});

		site.storefilter.filterMarkSelected();
		site.storefilter.filterDropdownClick();
	},
	filterMarkSelected: function() {
		$checkboxes = $('#filters .filter.Checkbox');
		$checkboxes.each(function () {
			$(this).find('input').each(function() {
				$(this).attr('id',$(this).attr('id').replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, ""));
				$(this).attr('value',$(this).attr('value').replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, ""));
				site.storefilter.filterMarkSelectedItem($(this),false);
			});
		});

		$checkboxes.find('input').on('change', function () {
			site.storefilter.filterMarkSelectedItem($(this),true);
		});
		//site.storefilter.filterRemoveTag();
	},
	filterMarkSelectedItem: function(item,mark) {
		//item = $(this);
		$parent = item.parents('.option');
		$label = $parent.find('label');
		var filterId = item.attr('id');
		if(mark) {
			$parent.toggleClass('selected');
		}
	},

	filterDropdownClick: function() {
		// Category dropdown
		$('body').on('click', '#rootCatFilter .filterTitle', function (e) {
			e.preventDefault();
			$('body').toggleClass('filter-open');

			var $parent = $('#rootCatFilter');
			$parent.toggleClass('open').find('.wrap').toggleClass('open');

			$('body.filter-open').on('click', function (e) {
				if (!$(e.target).parents('#rootCatFilter').length) {
					$('body').removeClass('filter-open');
					$parent.removeClass('open').find('.wrap').removeClass('open');
				}
			});
		});

		// Filter dropdown
		$('body').on('click', '#filters .filter >.label', function (e) {
			e.preventDefault();
			$('body').toggleClass('filter-open-first');

			var $parent = $(this).parent('.filter');
			$parent.toggleClass('open').find('.wrap').toggleClass('open');

			$('body.filter-open-first').on('click', function (e) {
				if($(e.target).parents('.storeCard').length) {
					window.location.href=$(e.target).parents('.storeCard').find('.more').attr('href');
				}
				if($(e.target).parents('.filter').index() !== $parent.index()) {
					$('body').removeClass('filter-open-first');
					$parent.removeClass('open').find('.wrap').removeClass('open');
				}
			});

		});
	},
};

site.storeLoad = {
	init: function() {
		if (!$('.paginationControl').length) {
			return;
		}
		var grid = $('.products');
		grid.infiniteScroll({
			path: 'a.stepper.next',
			append: '.product',
			status: '.scroller-status',
			hideNav: '.paginationControl',
			button: '#loadMore',
			history: false,
			loadOnScroll: false
		});

		grid.on( 'append.infiniteScroll', function( event, response, path, items ) {
			$( items )
				.css('opacity', 0)
				.css('opacity', 1);
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.filterCate.init();
	site.storefilter.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

store.local.onFilterUpdate = function () {
	var $checkboxes = $('#filters .filter.Checkbox');
	$checkboxes.find('input').each(function () {
		if($(this).is(':checked')) {
			site.storefilter.filterMarkSelectedItem($(this),true);
		}
		else {
			$('.storeTags .'+$(this).attr('id')).remove();
		}
	});

};

